import { UploadButton } from '@components/MediaUploadBox/UploadButton';
import { showToast } from '@lib/utils/toastmaster';
import { useAddVideosModal } from '@pages/Library/context/AddVideosModalContext';
import { useLibrary } from '@stores/Library/Library';
import { useLibraryFolder } from '@stores/Library/LibraryFolder';
import { userStore } from '@stores/User';
import { observer } from 'mobx-react';
import { ComponentProps } from 'react';

/** "Add media" into the folder on screen, with the library's rules for when it's disabled. */
export const LibraryAddMediaButton = observer(
  ({ renderTrigger }: Pick<ComponentProps<typeof UploadButton>, 'renderTrigger'>) => {
    const library = useLibrary();
    const folder = useLibraryFolder();
    const addVideosModal = useAddVideosModal();
    return (
      <UploadButton
        variant="primary"
        text="Add media"
        disabled={!userStore.data?.isVerified || library.isReadOnly || !library.stats}
        destination={{
          libraryId: library.libraryId,
          folderPath: folder.currentFolderPath,
        }}
        tooltipTitle={
          library.isReadOnly
            ? "You can't add media to this library because it is read-only"
            : !userStore.data?.isVerified
              ? 'Please verify your email to add media.'
              : 'Upload or add media links'
        }
        onRegisterClose={
          addVideosModal ? (getClose) => addVideosModal.registerClose(getClose) : undefined
        }
        onDisabledClick={library.isReadOnly ? () => showToast('library-read-only') : undefined}
        renderTrigger={renderTrigger}
      />
    );
  },
);
